import { useNavigate } from "react-router-dom";
import { CustomTextFieldNoForm, CustomTextFieldNumberComponente, GeneralTable } from "@/shared/components/ui";
import { getSolicitudesTutorDescuentos, useFetchProspecto, useFetchUpdateProspecto } from "@/shared/actions/erp";
import { useTableFilter, useTableServerSideFiltering, useCheckPermissionsArray, useLoaders } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { FormVendedoProspecto, IDataProspecto } from "@/shared/interfaces/erp/prospecto";
import { useTableColumnsProspecto } from "@/shared/hooks/useTableColumnsProspecto";
import {
  EstadoProspectoEnum, getSolicitudBeneficioLabel, gridSizeMdLg12, gridSizeMdLg6, hasAllPermissions,
  hasPermission, ModulosEnumChoice, newEditarProspecteoSchema,
  newProspectoCambioVendedorSchema, RolChoiceEnum, ROUTER_PATHS,
  TABLE_CONSTANTS, texto
} from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";
import CustomSearchFilterSupervisorVenta from "../componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import Edit from "@mui/icons-material/Edit";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState } from "react";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { AlertSeverityEnum, FormEditProspecto, SolicitudTutorDescuentoEstadoSolicitudEnum } from "@/shared/interfaces";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useAuthStore } from "@/store/auth";
import { useUiStore } from "@/store/ui";
import { useModalMotivoRechazo } from "@/shared/components/ui/ModalMotivoRechazo/useModalMotivoRechazo";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import CustomAutoCompleteVendedor from "../componente/CustomAutoCompleteVendedor/CustomAutoCompleteVendedor";

export default function ProspectoEsperaPage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_prospecto,
    PermissionsEnum.api_change_prospecto,
    PermissionsEnum.api_view_motivorechazo
  ]);

  const setAlert = useUiStore((s) => s.setAlert);
  const userRol = useAuthStore(s => s.user)?.rol;

  const navigate = useNavigate();

  ///* use state
  const [modal, setModal] = useState(false);
  const [modalUser, setModalUser] = useState(false);


  ///* form
  const form = useForm<FormEditProspecto>({
    resolver: yupResolver(newEditarProspecteoSchema),
  });

  const {
    reset,
    control,
    formState: { errors },
  } = form;

  const form2 = useForm<FormVendedoProspecto>({
    resolver: yupResolver(newProspectoCambioVendedorSchema)
  });

  const {
    reset: reset2,
  } = form2;

  ///* Hooks

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PROSPECTO
  })
  const { columnsBase } = useTableColumnsProspecto({ estado_prospecto: EstadoProspectoEnum.EN_ESPERA });

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,

    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor,

  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const { isLoading, data: prospectoRes, isRefetching } =
    useFetchProspecto({
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      estado_prospecto: EstadoProspectoEnum.EN_ESPERA,
      fecha_creacion_before: dateBefore,
      fecha_creacion_after: dateAfter,
      user_create: vendedor,
      ...filterObject,
      filterByState: false
    });

  const {
    mutateAsync: mutateAsyncProspecto,
    isPending: isPendingPutProspecto
  } = useFetchUpdateProspecto({
    enableAlert: true
  })

  ///* Funciones

  const onEdit = async (prospecto: IDataProspecto) => {

    const dataSolicitud = await getSolicitudesTutorDescuentos({
      prospecto: prospecto.codigo
    })

    if (dataSolicitud.data.count != 0) {

      const infoData = dataSolicitud.data.data[0].estado_solicitud;

      switch (infoData) {
        case SolicitudTutorDescuentoEstadoSolicitudEnum.RECHAZADO:
          return setAlert(true, 'La solicitud de ingreso fue rechazada.', AlertSeverityEnum.warning);
        case SolicitudTutorDescuentoEstadoSolicitudEnum.EN_ESPERA:
          return setAlert(true, `El prospecto tiene una solicitud "${getSolicitudBeneficioLabel({
            es_bono_humano: prospecto.es_bono_humano,
            es_gremio: prospecto.es_gremio,
            es_reportado: prospecto.es_reportado,
            reportado: prospecto.reportado,
            es_tutor: prospecto.es_curador_tutor,
            es_ayuda_social: prospecto.es_ayuda_social
          })}" de ingreso que aún no ha sido revisada.`, AlertSeverityEnum.info);
        case SolicitudTutorDescuentoEstadoSolicitudEnum.APROBADO:
          return navigate(`${ROUTER_PATHS.ventas.preventasCrearNav}/${prospecto.id_prospecto}`);
        default:
          break;
      }

      return;
    }

    return navigate(`${ROUTER_PATHS.ventas.preventasCrearNav}/${prospecto.id_prospecto}`);
  }

  useLoaders(
    isPendingPutProspecto
  )

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"

            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
            setVendedor={setVendedor}
          //vendedor={vendedor}
          />
        </Grid>

        <Grid item xs={12}>
          <GeneralTable<IDataProspecto>
            columns={columnsBase}
            data={prospectoRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}
            // onGlobalFilterChange={setGlobalFilter}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={prospectoRes?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            showCustomActionBtnSpace={hasPermission(
              PermissionsEnum.api_change_prospecto
            )}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_BIG}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  {
                    hasPermission(PermissionsEnum.api_add_preventa) && (
                      <Grid item >
                        <Tooltip title={'Crear Preventa'} placement="top">
                          <IconButton
                          color="inherit"
                            onClick={() =>
                              onEdit(value)
                            }
                          >
                            <PostAddIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )
                  }

                  {
                    hasAllPermissions([
                      PermissionsEnum.api_change_prospecto,
                      PermissionsEnum.api_view_empleado,
                    ]) && userRol == RolChoiceEnum.SUPERVISOR && (
                      <Grid>
                        <Tooltip placement="top" title='Cambiar'>
                          <IconButton
                            onClick={() => {
                              console.log(value);
                              setModalUser(true);
                              reset2({
                                vendedor_actual: value.user_create,
                                id_prospecto: value.id_prospecto
                              })
                            }}
                          >
                            <PersonSearchIcon color="info" />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )
                  }

                  {
                    hasPermission(PermissionsEnum.api_change_prospecto) && (
                      <>
                        <Grid item>
                          <Tooltip title={'Editar'} placement="top">
                            <IconButton
                              onClick={() => {
                                setModal(true)
                                reset({ celular: value.celular, id_prospecto: value.id_prospecto })
                              }
                              }
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                        </Grid>

                        <Grid item>
                          <Tooltip title={texto.cancelado} placement="top">
                            <IconButton
                              onClick={() => {
                                useHookModalMotivoRechazo.setDialogContentText(`Estás a punto de cancelar un Prospecto del cliente ${value.razon_social} con identificación ${value.identificacion}. ¿Estás seguro? Este cambio es irreversible.`)
                                useHookModalMotivoRechazo.setModalCancelar(true)
                                useHookModalMotivoRechazo.reset({
                                  id: value.id_prospecto,
                                  identificacion: value.identificacion,
                                  razon_social: value.razon_social
                                })
                              }
                              }
                            >
                              <HighlightOffIcon color="error" />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </>
                    )
                  }

                </Grid>
              )
            }
            }

          />
        </Grid>
      </Grid>


      {/*Modal para cancelar*/}

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />

      {/*Modal para editar numero de celular*/}

      {modal && (
        <ScrollableDialogProps
          open={modal}
          title="Editar Información de Prospecto"
          confirmTextBtn="Cambiar"
          contentNode={
            <Grid container spacing={3}>
              <CustomTextFieldNumberComponente
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={control}
                name="celular"
                defaultValue={form.getValues().celular || ''}
              />
            </Grid>
          }
          onConfirm={form.handleSubmit(async () => {
            await mutateAsyncProspecto({
              id: form.getValues().id_prospecto,
              data: {
                celular: form.getValues().celular
              }
            });
            reset({ celular: '', id_prospecto: '' });
            setModal(false);
          })}
          onClose={() => setModal(false)}
        />
      )
      }

      {/*Modal para cambiar de vendedor*/}
      {
        modalUser && (
          <ScrollableDialogProps
            open={modalUser}
            title="Cambiar Vendedor"
            confirmTextBtn="Cambiar"
            contentNode={
              <Grid container spacing={2}>

                <CustomTextFieldNoForm
                  label="Vendedor actual"
                  value={form2.getValues().vendedor_actual}
                  disabled
                  size={gridSizeMdLg6}
                />

                <Grid item {...gridSizeMdLg6}>
                  <CustomAutoCompleteVendedor
                    onChangeValue={(value) => {
                      console.log(value);
                      form2.setValue('vendedor_nuevo', value.user ?? '')
                    }}
                  />
                </Grid>

                {/* <CustomAutocomplete<Empleado>
                  size={gridSizeMdLg6}
                  label={'Asignar vendedor'}
                  name="vendedor_nuevo"
                  options={empleadoVenta || []}
                  valueKey="razon_social"
                  actualValueKey="user"
                  defaultValue={vendedor}
                  isLoadingData={isLoadingEmpleadoVenta}
                  control={form2.control}
                  error={form2.formState.errors.vendedor_nuevo}
                  helperText={form2.formState.errors.vendedor_nuevo?.message}
                /> */}
              </Grid>
            }
            onConfirm={form2.handleSubmit(async (form) => {
              await mutateAsyncProspecto({
                id: form2.getValues().id_prospecto,
                data: {
                  user_create: form.vendedor_nuevo
                }
              })
              reset2({})
              setModalUser(false)
            })}
            onClose={() => setModalUser(false)}
          />
        )
      }

    </>

  );



}